var React = require('react');

function ShapeSeparatorInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"coral","d":"M15 14H0V7h15z","key":0}),React.createElement("path",{"fill":"#59C6C4","d":"M40.963.925l9.227 9.256-9.227 9.257-9.228-9.256z","key":1}),React.createElement("circle",{"cx":"78","cy":"11","r":"9","fill":"#CA76A0","key":2})]));
}

ShapeSeparatorInline.defaultProps = {"viewBox":"0 0 87 20"};

module.exports = ShapeSeparatorInline;

ShapeSeparatorInline.default = ShapeSeparatorInline;
